
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.45","height":"20.064"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 5582"}},[_c('g',{attrs:{"data-name":"Group 5575"}},[_c('g',{attrs:{"data-name":"Group 5574"}},[_c('path',{attrs:{"data-name":"Path 5388","d":"M14.066 7.9H1.384a.634.634 0 00-.634.634V18.68a.634.634 0 00.634.634h12.682a.634.634 0 00.634-.634V8.534a.634.634 0 00-.634-.634zm-4.547 5.7a1.9 1.9 0 01-1.159 1.159v1.385a.634.634 0 01-.634.634.634.634 0 01-.634-.634v-1.385a1.9 1.9 0 01-1.159-2.428 1.9 1.9 0 012.428-1.159 1.9 1.9 0 011.158 2.427z","fill":"none","stroke":"#a8dded","stroke-miterlimit":"10","stroke-width":"1.5"}})])]),_c('path',{attrs:{"data-name":"Path 5389","d":"M3.072 7.901v-2.5A4.653 4.653 0 017.725.748a4.653 4.653 0 014.653 4.653v2.5","fill":"none","stroke":"#a8dded","stroke-miterlimit":"10","stroke-width":"1.5"}})])])
          )
        }
      }
    